import {MyNav} from "./MyNav";
import {Sidebar} from "../Sidebar/Sidebar";
import {Footer} from "./Footer";
import {Outlet, useNavigate} from "react-router-dom";
import {useContext, useEffect} from "react";
import {UserContext} from "../../Context/UserContext";

export const BaseLayout = () => {

    console.log('Renderizando o BaseLayout, feito')
    const navigate = useNavigate();
    const {currentUser} = useContext(UserContext);


    useEffect(() => {
        if (!currentUser) {
            navigate('/entrar');
        }
    }, [currentUser]);


    return (
        <>
            <MyNav/>
            <Sidebar/>
            <div className="content-wrapper">
                <Outlet/>
            </div>
            <Footer/>
        </>
    )
}
